// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'acuminproSemiboldWebfont', 'acuminproSemiboldWebfont Fallback'"},"className":"__className_f4f88f","variable":"__variable_f4f88f"};